import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteEmojiMutation = createMutationHook(MembershipsCreatorApiClient.deleteEmoji, {
  mutationKey: ['deleteEmoji'],
})
